// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedContentRouteImport } from './routes/_authenticated/content'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedExpensesRouteImport } from './routes/_authenticated/expenses'
import { Route as AuthenticatedMarketingRouteImport } from './routes/_authenticated/marketing'
import { Route as AuthenticatedPaywallRouteImport } from './routes/_authenticated/paywall'
import { Route as AuthenticatedPipelineRouteImport } from './routes/_authenticated/pipeline'
import { Route as AuthenticatedRevenueRouteImport } from './routes/_authenticated/revenue'
import { Route as AuthenticatedScorecardRouteImport } from './routes/_authenticated/scorecard'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedTasksRouteImport } from './routes/_authenticated/tasks'
import { Route as AuthenticatedVaultRouteImport } from './routes/_authenticated/vault'
import { Route as AuthenticatedVisionRouteImport } from './routes/_authenticated/vision'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as PSlugRouteImport } from './routes/p/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedContentRoute = AuthenticatedContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedExpensesRoute = AuthenticatedExpensesRouteImport.update({
            id: '/expenses',path: '/expenses',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMarketingRoute = AuthenticatedMarketingRouteImport.update({
            id: '/marketing',path: '/marketing',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPaywallRoute = AuthenticatedPaywallRouteImport.update({
            id: '/paywall',path: '/paywall',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPipelineRoute = AuthenticatedPipelineRouteImport.update({
            id: '/pipeline',path: '/pipeline',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedRevenueRoute = AuthenticatedRevenueRouteImport.update({
            id: '/revenue',path: '/revenue',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedScorecardRoute = AuthenticatedScorecardRouteImport.update({
            id: '/scorecard',path: '/scorecard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedTasksRoute = AuthenticatedTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedVaultRoute = AuthenticatedVaultRouteImport.update({
            id: '/vault',path: '/vault',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedVisionRoute = AuthenticatedVisionRouteImport.update({
            id: '/vision',path: '/vision',getParentRoute: () => AuthenticatedRouteRoute
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedContentRoute: AuthenticatedContentRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedExpensesRoute: AuthenticatedExpensesRoute,AuthenticatedMarketingRoute: AuthenticatedMarketingRoute,AuthenticatedPaywallRoute: AuthenticatedPaywallRoute,AuthenticatedPipelineRoute: AuthenticatedPipelineRoute,AuthenticatedRevenueRoute: AuthenticatedRevenueRoute,AuthenticatedScorecardRoute: AuthenticatedScorecardRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedTasksRoute: AuthenticatedTasksRoute,AuthenticatedVaultRoute: AuthenticatedVaultRoute,AuthenticatedVisionRoute: AuthenticatedVisionRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,ResetPasswordRoute: ResetPasswordRoute,CheckoutReturnRoute: CheckoutReturnRoute,PSlugRoute: PSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)